/*
 * Copyright (c) AXA Group Operations Spain S.A.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

const { Stopwords } = require('@nlpjs/core');

class StopwordsFr extends Stopwords {
  constructor(container, words) {
    super(container);
    this.name = 'stopwords-fr';
    this.dictionary = {};
    const list = words || [
      'être',
      'avoir',
      'faire',
      'a',
      'au',
      'aux',
      'avec',
      'ce',
      'ces',
      'dans',
      'de',
      'des',
      'du',
      'elle',
      'en',
      'et',
      'eux',
      'il',
      'je',
      'la',
      'le',
      'leur',
      'lui',
      'ma',
      'mais',
      'me',
      'même',
      'mes',
      'moi',
      'mon',
      'ne',
      'nos',
      'notre',
      'nous',
      'on',
      'ou',
      'où',
      'par',
      'pas',
      'pour',
      'qu',
      'que',
      'qui',
      'sa',
      'se',
      'ses',
      'son',
      'sur',
      'ta',
      'te',
      'tes',
      'toi',
      'ton',
      'tu',
      'un',
      'une',
      'vos',
      'votre',
      'vous',
      'c',
      'd',
      'j',
      'l',
      'à',
      'm',
      'n',
      's',
      't',
      'y',
      'été',
      'étée',
      'étées',
      'étés',
      'étant',
      'suis',
      'es',
      'est',
      'sommes',
      'êtes',
      'sont',
      'serai',
      'seras',
      'sera',
      'serons',
      'serez',
      'seront',
      'serais',
      'serait',
      'serions',
      'seriez',
      'seraient',
      'étais',
      'était',
      'étions',
      'étiez',
      'étaient',
      'fus',
      'fut',
      'fûmes',
      'fûtes',
      'furent',
      'sois',
      'soit',
      'soyons',
      'soyez',
      'soient',
      'fusse',
      'fusses',
      'fût',
      'fussions',
      'fussiez',
      'fussent',
      'ayant',
      'eu',
      'eue',
      'eues',
      'eus',
      'ai',
      'as',
      'avons',
      'avez',
      'ont',
      'aurai',
      'auras',
      'aura',
      'aurons',
      'aurez',
      'auront',
      'aurais',
      'aurait',
      'aurions',
      'auriez',
      'auraient',
      'avais',
      'avait',
      'avions',
      'aviez',
      'avaient',
      'eut',
      'eûmes',
      'eûtes',
      'eurent',
      'aie',
      'aies',
      'ait',
      'ayons',
      'ayez',
      'aient',
      'eusse',
      'eusses',
      'eût',
      'eussions',
      'eussiez',
      'eussent',
      'ceci',
      'cela',
      'cet',
      'cette',
      'ici',
      'ils',
      'les',
      'leurs',
      'quel',
      'quels',
      'quelle',
      'quelles',
      'sans',
      'soi',
    ];
    this.build(list);
  }
}

module.exports = StopwordsFr;
